import DeptManagerTree from './src/main';

/* istanbul ignore next */
DeptManagerTree.install = function(Vue) {
  Vue.component(DeptManagerTree.name, DeptManagerTree);
};

export default DeptManagerTree;
